declare global {
  interface Window {
      __ORDERLY_VERSION__?: {
          [key: string]: string;
      };
  }
}
if (typeof window !== "undefined") {
  window.__ORDERLY_VERSION__ = window.__ORDERLY_VERSION__ || {};
  window.__ORDERLY_VERSION__["@orderly.network/default-solana-adapter"] = "3.1.2";
}

export default "3.1.2";
